<template>
  <v-autocomplete :value="value" :items="items" :item-text="itemText" :item-value="itemValue" :light="light"
                  :error-messages="errorMessages" :label="label" :required="required" :solo="solo" :readonly="readonly"
                  chips multiple @input="handleInput" no-data-text="No hay datos disponibles" :loading="loading"
                  :prepend-icon="prependIcon" :disabled="disabled">
    <v-list-tile slot="prepend-item" ripple @click="selectAll">
      <v-list-tile-action></v-list-tile-action>
      <v-list-tile-title>Seleccionar todos</v-list-tile-title>
    </v-list-tile>
    <v-divider slot="prepend-item"></v-divider>
  </v-autocomplete>
</template>

<script>
export default {
  props: {
    value: Array,
    items: Array,
    itemText: String,
    itemValue: String,
    errorMessages: Array,
    label: String,
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    solo: Boolean,
    light: Boolean,
    readonly: Boolean,
    loading: Boolean,
    prependIcon: String
  },

  methods: {
    selectAll () {
      if (this.value.length === this.items.length) {
        this.$emit('input', [])
      } else {
        this.$emit('input', this.items.map(item => (item[this.itemValue])))
      }
    },
    handleInput (event) {
      this.$emit('input', event)
    }
  }
}
</script>
